import { Controller } from "@hotwired/stimulus"

// Floating support widget: toggles panel, lazy-loads conversation frame,
// and heartbeats while open so the admin panel can show presence.
export default class extends Controller {
  static targets = ["panel", "frame"]
  static values = {
    heartbeatUrl: String,
    conversationId: Number,
    open: { type: Boolean, default: false }
  }

  connect() {
    this.heartbeatTimer = null
  }

  disconnect() {
    this.stopHeartbeat()
  }

  toggle(event) {
    event?.preventDefault()
    this.openValue = !this.openValue
    this.panelTarget.classList.toggle("hidden", !this.openValue)
    if (this.openValue) {
      this.reloadFrame()
      this.startHeartbeat()
    } else {
      this.stopHeartbeat()
    }
  }

  close(event) {
    event?.preventDefault()
    this.openValue = false
    this.panelTarget.classList.add("hidden")
    this.stopHeartbeat()
  }

  reloadFrame() {
    if (!this.hasFrameTarget) return
    const src = this.frameTarget.getAttribute("data-src")
    if (src) this.frameTarget.src = src
  }

  startHeartbeat() {
    this.stopHeartbeat()
    if (!this.heartbeatUrlValue) return
    this.heartbeatTimer = window.setInterval(() => this.ping(), 30000)
    this.ping()
  }

  stopHeartbeat() {
    if (this.heartbeatTimer) {
      window.clearInterval(this.heartbeatTimer)
      this.heartbeatTimer = null
    }
  }

  ping() {
    if (!this.heartbeatUrlValue) return
    const token = document.querySelector("meta[name='csrf-token']")?.content
    fetch(this.heartbeatUrlValue, {
      method: "POST",
      headers: {
        "X-CSRF-Token": token || "",
        Accept: "text/plain"
      },
      credentials: "same-origin"
    }).catch(() => {})
  }
}
